module.exports = __webpack_public_path__ + "static/media/offer.723fdd9f.svg";